import type { ClarityDashboardTab } from './clarity-dashboard-tabs.constant';

/**
 * The URL segment the assistant screen lives at under the Clarity section: `/clarity/assistant`.
 *
 * Shared because three layers must agree on it — the application's route, the tab strip's tab id and
 * the visibility entry that decides whether that tab is shown at all — and a tab whose id has drifted
 * from the route is hidden by an entry nobody matches or routed to a screen the strip never offers, so
 * all three read this one declaration rather than three literals. `type:util` is the one layer all
 * three may reach.
 *
 * `satisfies ClarityDashboardTab` keeps the value the literal `'assistant'` while making a typo a
 * compile error against the dashboard-tab union instead of a silently wrong segment.
 */
export const CLARITY_ASSISTANT_ROUTE_SEGMENT = 'assistant' satisfies ClarityDashboardTab;
